module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/170329-002-DS-390914e94e96ad22fe7411f5226331a7.jpg";